import { FaCheckCircle, FaCog, FaMapMarked, FaShip, FaTimesCircle, FaUserCheck, FaUserCog, FaUserSecret, FaUserShield, FaUserTie } from "react-icons/fa";
import { FcAddRow, FcAdvertising, FcApproval, FcAssistant, FcAutomatic, FcBinoculars, FcBiomass, FcBookmark, FcBriefcase, FcBusinessman, FcButtingIn, FcCalendar, FcCallback, FcCancel, FcCheckmark, FcClearFilters, FcClock, FcCollaboration, FcConferenceCall, FcDeleteRow, FcDisclaimer, FcFullTrash, FcGenealogy, FcHeatMap, FcImport, FcInspection, FcInTransit, FcLike, FcLikePlaceholder, FcManager, FcOk, FcOrgUnit, FcPlus, FcPrint, FcProcess, FcReading, FcSearch, FcSerialTasks, FcServices, FcShipped, FcSurvey, FcTodoList, FcVoicePresentation } from "react-icons/fc";
import { MdOutlineTrackChanges } from "react-icons/md";
import { FaClock, FaMoneyBillWave, FaTrash, FaTruck } from "react-icons/fa6";
import { IoMdBoat } from "react-icons/io";
import { User, FileText, MessageCircle, Heart, Settings, MapPin, BookOpen, Briefcase, Info } from "lucide-react";
import { ImProfile, ImExit } from "react-icons/im";
import man from "./man.avif";
import woman from "./woman.avif";

// https://html-css-js.com/html/character-codes/icons/

const menuIcon =    <svg className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d='M4 6h16M4 12h16M4 18h16'
                />
              </svg>;

const menuClose =    <svg className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d='M6 18L18 6M6 6l12 12'
                />
              </svg>;


export const myIcons = {
  man,
  woman,
  menuIcon,
  menuClose,
  clock: <FaClock size={25} />,
  success: <FaCheckCircle className="mr-1" />,
  error: <FaTimesCircle className="mr-1" />,
  ship: <FaShip size={25} />,
  boat: <IoMdBoat size={25}/>,
  vessels: <FcHeatMap size={25} />,
  order: <FcBookmark size={25} />,
  order2: <FcSurvey size={25} />,
  shipped: <FcShipped size={25} />,
  tracking: <FcSerialTasks size={25} />,
  brifcase: <FcBriefcase size={25} />,
  setting: <FcAutomatic size={25} />,
  approved: <FcApproval size={25} />,
  alert: <FcAdvertising size={25} />,
  todo: <FcTodoList size={25} />,
  heart: <FcLike size={25} />,
  heart_lite: <FcLikePlaceholder size={25} />,
  stop: <FcDisclaimer size={25} />,
  management: <FcOrgUnit size={25} />,
  delete: <FcFullTrash size={25} />,
  variety: <FcBiomass size={25} />,
  varieties: <FcGenealogy size={25} />,
  search: <FcSearch size={25} />,
  services: <FcServices size={25} />,
  notify: <FcVoicePresentation size={25} />,
  date: <FcCalendar size={25} />,
  correct: <FcCheckmark size={25} />,
  ok: <FcOk size={25} />,
  plus: <FcPlus size={25} />,
  print: <FcPrint size={25} />,
  read: <FcReading size={25} />,
  reload: <FcProcess size={25} />,
  import: <FcImport size={25} />,
  inspect: <FcInspection size={25} />,
  clear: <FcClearFilters size={25} />,
  transport: <FcInTransit size={25} />,
  call: <FcCallback size={25} />,
  cancel: <FcCancel size={25} />,
  addRow: <FcAddRow size={25} />,
  delRow: <FcDeleteRow size={25} />,
  users: <FcConferenceCall size={25} />,
  collab: <FcCollaboration />,
  dashboardUser: <FcAssistant />,
  dashboardVerified: <FaUserCheck size={25} />,
  dashboardDelivery: <FaUserTie size={25} />,
  dashboardAdmin: <FaUserCog size={25} />,
  dashboardSupervisor: <FaUserShield size={25} />,
  dashboardSAdmin: <FaUserSecret size={25} />,
  dashboardOwner: <FcBusinessman />,
  track: <MdOutlineTrackChanges size={25} />,
  manager: <FcManager size={25} />,
  binoculars: <FcBinoculars size={25} />,
  map: <FaMapMarked size={25} />,
  login: <FcButtingIn size={30} />,
  register: <FcCollaboration size={30} />,
  fileText: FileText,
  profile: ImProfile,
  user: User,
  message: MessageCircle,
  heart2: Heart,
  settings:Settings,
  logout:ImExit,
  mappin:MapPin,
  bookopen:BookOpen,
  briefcase:Briefcase,
  info:Info
};

export default myIcons;

  export const iconMap = {
    FaClock: <FaClock />,
    FaCog: <FaCog />,
    FaTruck: <FaTruck />,
    FaCheckCircle: <FaCheckCircle />,
    FaTimesCircle: <FaTimesCircle />,
    FaMoneyBillWave: <FaMoneyBillWave />,
    FaTrash: <FaTrash />,
  };